// ====================== Mode ======================
export function getRealPlacement(placement, rtl) {
  if (placement !== undefined) {
    return placement;
  }
  return rtl ? 'bottomRight' : 'bottomLeft';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/utils/uiUtil.js
// module id = 1730
// module chunks = 0